// Videos on sales activities. They are kept at Bunny Stream, and on an activity
// they look like any other file: { url, name }.
export const VIDEO_URL_PREFIX = '/api/sales/videos/';
export const VIDEO_EXTENSIONS = ['.mp4', '.mov', '.m4v', '.webm', '.avi', '.mkv'];

export const isVideoFile = (name) => {
  const lower = (name || '').toLowerCase();
  return VIDEO_EXTENSIONS.some(ext => lower.endsWith(ext));
};

export const isVideoUrl = (url) => (url || '').startsWith(VIDEO_URL_PREFIX);

export const videoIdOf = (url) => (isVideoUrl(url) ? url.slice(VIDEO_URL_PREFIX.length) : '');

// Whole percent sent. Stays below 100 until Bunny confirms the upload.
export const percentSent = (sent, total) => (total > 0 ? Math.min(99, Math.floor((sent / total) * 100)) : 0);
